(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('AppraisalReportSearch', AppraisalReportSearch);

    AppraisalReportSearch.$inject = ['$resource'];

    function AppraisalReportSearch($resource) {
        var resourceUrl =  'api/_search/appraisal-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
